module.exports = __webpack_public_path__ + "img/FLSH3.fcbc6ea4.svg";